export const RADIO_SIZE = {
  large: 'large',
  medium: 'medium',
  small: 'small',
  xSmall: 'xSmall',
}
